export class TitleDto {
  id: string;
  TitleName: string;
  SubscriptionUserId: string;
  SubscriberId: string;
  dateCreated: Date;
  dateUpdated?: Date;
  CreatedById: string;
  ModifiedById: string;
  SiteId: string;
  Version: number;
}
